import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const BlockContainer = styled.div`
  display: flex;
`;

export const BillingLeftSection = styled.div`
  flex-direction: column;
  display: inline-flex;
  min-width: 295px;
  padding: 60px 30px 0 30px;

  & > a {
    margin-bottom: 15px;
  }

  @media (max-width: 720px) {
    min-width: 295px;
    & > a {
      margin-right: 10px;
    }

  }
`;

export const BillingLink = styled(NavLink)`
  color: var(--DarkGray);
  transition: 0.1s ease;
  text-decoration: none;
  align-items: center;
  font-size: 19px;
  display: flex;

  & span {
    margin-left: 18px;
    display: inline-block;
  }

  &:hover,
  &:active,
  &.active {
    color: #414042;
    font-weight: 600;
  }
`;

export const BillingRightSection = styled.div`
  width: 100%;
`;

export const SponsorshipDiscountHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 20px 0; ;
`;

export const SponsorshipDiscountHeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 20px;
`;

export const SponsorshipDiscountHeaderRight = styled.div`
  border-bottom-left-radius: 11px;
  padding: 10px 10px 10px 10px;
  border-top-left-radius: 11px;
  background-color: #f54b23;
  justify-content: flex-start;
  font-weight: 600;
  margin-left: 30px;
  font-size: 34px;
  display: flex;
  color: #fff;
`;

export const SponsorshipDiscountHeaderTitle = styled.span`
  color: #ffffff;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
`;

export const SponsorshipDiscountHeaderSubtitle = styled.span`
  color: #ffffff;
  font-weight: 500;
  font-size: 25px;
`;

export const SponsorshipDiscountFooter = styled.div`
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #5d6e81;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  font-size: 15px;
  color: #fff;
  display: flex;
`;

export const SponsorshipLevelDiscount = styled.div`
  background-color: #334355;
  border-radius: 10px;
  margin-top: 22px;
  cursor: pointer;
  max-height: 109px;
`;